import { render, staticRenderFns } from "./go-up-button.vue?vue&type=template&id=578e3100&scoped=true&"
import script from "./go-up-button.vue?vue&type=script&lang=js&"
export * from "./go-up-button.vue?vue&type=script&lang=js&"
import style0 from "./go-up-button.vue?vue&type=style&index=0&id=578e3100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e3100",
  null
  
)

export default component.exports